import router from '@/router.js'
import store from '@/store'

export const prepareResponse = function ({
  response,
  api,
  routePath,
  options
}) {
  if (response.code === 401) {
    router.push({ name: 'Login' })
    store.dispatch('snackbar/snackbar', {
      open: true,
      text: 'Your login expired. Please log in again.',
      timeout: 10000
    })
    options.reject()
    return
  }
  if (api === 'resources') {
    if (routePath === '/resources/search/business_folders') {
      if (response.status === 'error') {
        response = {
          status: 'success',
          payload: {
            folders: []
          }
        }
      }
    }
    if (routePath === '/resources/search/business_files') {
      if (response.status === 'error') {
        response = {
          status: 'success',
          payload: {
            files: []
          }
        }
      }
    }
  }
  return response
}

export default {
  prepareResponse
}
